/**
 * Checks whether SHA-256 hashing is available in the current environment — crypto.subtle is
 * unavailable on local-change.org (HTTP, not HTTPS) and within TestCafe.
 */
export function canHashSha256(): boolean {
	return !!crypto.subtle;
}

export async function hashSha256(data: string): Promise<string> {
	const encoded = new TextEncoder().encode(data);
	const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
	return Array.from(new Uint8Array(hashBuffer))
		.map((b) => b.toString(16).padStart(2, '0'))
		.join('');
}
